import * as yup from "yup";

import { requiredCheckboxMessage } from "../validationMessages";

export const summaryConsentValidatorRequired = yup
  .string()
  .matches(/true/, { message: requiredCheckboxMessage });
